import React from "react";
import Section from "../components/Section";

function PolicyChanges() {
  return (
    <Section id="changes" icon="📝" title="Changes to This Policy">
      <p>
        We may update this Privacy Policy from time to time to reflect changes in the App or
        applicable law. When we do, we will update the "Last updated" date at the top of this page.
        We encourage you to review this policy periodically. Continued use of the App after changes
        are posted constitutes your acceptance of the updated policy.
      </p>
    </Section>
  );
}

export default PolicyChanges;
